import React, { FC } from 'react';
import { EnterpriseSnippet } from './enterprise/EnterpriseSnippet';
import { LawyerSnippet } from './lawyer/LawyerSnippet';
import { LegalBasisSnippet } from './legal-basis/LegalBasisSnippet';
import { SearchCommentarySnippet } from '../main/commentary/SearchCommentarySnippet';
import { Connect, PropsFromRedux } from './AsideSearchSnippetsContainer';
import { LegislationSnippet } from '../main/legislation/LegislationSnippet';
import { LegislativeTextSnippet } from '../../../../components/legislative-text-snippet/LegislativeTextSnippet';

type Props = PropsFromRedux;

export const RawAsideSearchSnippets: FC<Props> = ({
  enterprise,
  lawyer,
  hasLegalBasis,
  commentariesSnippet,
  legislationSnippet,
  originalQueryKey,
}) => {
  const snippetType = legislationSnippet?.type ?? 'article';
  return (
    <>
      {legislationSnippet && snippetType === 'article' && (
        <LegislationSnippet
          originalQueryKey={originalQueryKey}
          legislation={legislationSnippet}
        />
      )}
      {legislationSnippet && snippetType === 'text' && (
        <LegislativeTextSnippet
          href={legislationSnippet.url}
          title={legislationSnippet.title}
          articleCount={legislationSnippet.articleCount}
          source="law-snippet"
        />
      )}
      {!!enterprise && (
        <EnterpriseSnippet
          enterprise={enterprise}
          key={enterprise.enterpriseId}
        />
      )}
      {!!lawyer && <LawyerSnippet lawyer={lawyer} key={lawyer.lawyerId} />}
      {!!commentariesSnippet && (
        <SearchCommentarySnippet commentaries={commentariesSnippet} />
      )}
      {hasLegalBasis && <LegalBasisSnippet />}
    </>
  );
};

export const AsideSearchSnippets = Connect(RawAsideSearchSnippets);
